import React from 'react';
import { motion } from 'framer-motion';
import './style.scss';
import mobileLogo from '../../images/mobile_logo.webp';
import titleDescription from './content.json';

interface HomeTitleProps {
	scrollToNextSection: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const HomeTitle: React.FC<HomeTitleProps> = ({ scrollToNextSection }) => {
	return (
		<motion.section
			className="title-container"
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: false, amount: 0.25 }}
			transition={{ duration: 0.5, ease: 'easeOut' }}
		>
			<div className="mobile-title-container">
				<img
					src={mobileLogo}
					alt="Rental Hiace terbaik di Bandung, Indonesia dengan armada modern | Ketaren Transport"
					className="logo-mobile"
					loading="lazy"
					height={'100%'}
					width={'100%'}
				/>
				<h3>Rental Hiace Bandung, Indonesia</h3>
			</div>
			<div className="location-title-container">
				<h3>Rental Hiace Bandung, Indonesia</h3>
			</div>
			<motion.section
				className="title-container-box"
				initial={{ opacity: 0, y: 50 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: false, amount: 0.25 }}
				transition={{ duration: 0.5, ease: 'easeOut' }}
			>
				<h1 className="title-text">
					Sewa Hiace Bandung - Aman, Nyaman, Terjangkau | Ketaren Transport
				</h1>
				<p className="title-description">{titleDescription.description}</p>
				<motion.div
					className="button"
					whileHover={{
						scale: 1.05,
						y: -5
					}}
					onClick={scrollToNextSection}
					transition={{
						type: 'spring',
						stiffness: 400,
						damping: 10
					}}
				>
					Pelajari Layanan Kami
				</motion.div>
			</motion.section>
		</motion.section>
	);
};

export default HomeTitle;
